<div class="florder-page" @fadeInAnimation>
  <div class="florder-page-title">
    <span class="title">
      {{ 'ORDERS.LIST.SUBTITLE' | translate }}
    </span>
    <div class="buttons">
      <eps-button (buttonClick)="createFlorder()" *ngIf="authorization.ORDER.CREATE" buttonIcon="plus-square" label="ORDERS.FILTER.BUTTONS.ADD_ORDER"></eps-button>
      &nbsp;
      <eps-button type="primary" (buttonClick)="createTemplate()" *ngIf="authorization.ORDER.CREATE_TEMPLATE" buttonIcon="plus-square" label="ORDERS.FILTER.BUTTONS.ADD_TEMPLATE"></eps-button>
    </div>
  </div>
  <div *ngIf="authorization.ORDER.QUERY">
    <div class="florder-page-search">
      <app-order-filter
        [definitions]="definitions"
        [filter]="filter"
        [filterValues]="filterValues"
        [shipTos]="shipTos"
        [isLoading]="ordersAreLoading"
        [isBusy]="isDownloading"
        [customers]="customers"
        (filterOrders)="filterFlorders($event)"
        (resetFilterClicked)="resetFilter()"
      ></app-order-filter>
    </div>
    <div class="florder-page-list" id="order-list">
      <app-order-list
        [definitions]="definitions"
        [filter]="filter"
        [isLoading]="ordersAreLoading"
        [isDownloading]="isDownloading"
        [isSuperUser]="isSuperUser"
        [orders]="orders.items"
        [totalItems]="orders.totalItems"
        [authorization]="authorization"
        [restrictions]="restrictions"
        (downloadFile)="downloadFile($event)"
        (openOrder)="openOrder($event)"
        (editCCR)="editCCR($event)"
        (createCCR)="createCCR($event)"
        (copyOrder)="copyOrder($event)"
        (asTemplate)="asTemplate($event)"
        (acceptDeviation)="acceptDeviation($event)"
        (rejectDeviation)="rejectDeviation($event)"
        (downloadDocument)="downloadDocument($event)"
        (downloadCCRDocument)="downloadCCRDocument($event)"
        (pageChange)="onPageChange($event)"
        (sortChange)="sortChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
        [customersAllowedCreateOrUpdate]="sandbox.customersAllowedCreateOrUpdate$ | async"
      ></app-order-list>
    </div>
  </div>
</div>
